import { readAsDataURL } from 'promise-file-reader';

import blobFactory from '@app/libs/blobFactory';

export async function pdfToBase64(pdf: ArrayBuffer) {
  const pdfAsBase64 = await readAsDataURL(blobFactory(pdf));

  return pdfAsBase64.split('base64,')[1];
}
